export interface ApiGetHiroBasicResponse {
    copilot_flag: boolean;
}

export const GetHiroBasic = Symbol.for('GetHiroBasic');

export interface GetHiroBasic {
    getHiroBasic(): Promise<ApiGetHiroBasicResponse>;
}